import ShiftUtils from 'services/ShiftUtils';
import CalendarUtils from 'services/CalendarUtils';
import Icon from 'components/Utils/NewIcon';
import React, { useMemo } from 'react';
import { useAppSelector } from 'careand-redux/store';
import PhysicianUtils from 'services/PhysicianUtils';

const ShiftBadge = ({
  shift = {},
  template,
  onClick,
  className,
  onDelete,
  color,
  overrideText,
  hideIcons = false,
}) => {
  const physicians = useAppSelector((state) => state.physicians.byId);
  const handovers = useAppSelector((state) => state.shifts.handovers);
  const templates = useAppSelector((state) => state.shifts.templates);

  if (!!template) shift = ShiftUtils.templateToShift(undefined, template);

  let { non_working, approved, breaks = [], telemedicine_only } = shift;

  let description = template?.name || ShiftUtils.getShiftDescription(shift);

  const handoverDescription = useMemo(() => {
    if (shift.id) {
      const handover = ShiftUtils.getActiveHandover(handovers, shift.user_id, shift.start);
      const coveredByPhysician = physicians[handover?.assigned_to_id];
      let coveredBy = undefined;
      if (coveredByPhysician) {
        coveredBy = `Covered by ${PhysicianUtils.getName(coveredByPhysician)}`;
      }
      return coveredBy;
    }
  }, [handovers, shift, physicians]);

  let shiftStyle = {
    background: color || ShiftUtils.getColor(shift, false, templates),
  };

  let shiftClassName = 'shift-pill';
  if (className) shiftClassName += ` ${className}`;
  if (shift.approved === false) shiftClassName += ' non-approved';
  if (shift.rejected === true) shiftClassName += ' rejected';

  let breakDescription;

  if (breaks.length > 0) {
    breakDescription = breaks
      .map((data) => {
        let { start_hour, end_hour, name } = data;
        let startDate = CalendarUtils.format(
          CalendarUtils.militaryTimeToUnix(shift.start, start_hour),
          'h:mmA',
        );
        let endDate = CalendarUtils.format(
          CalendarUtils.militaryTimeToUnix(shift.start, end_hour),
          'h:mmA',
        );
        return `${name}: ${startDate} - ${endDate}`;
      })
      .join('\n');
  }

  return (
    <div className={shiftClassName} style={shiftStyle} onClick={onClick}>
      {!hideIcons && (
        <div className="icon-wrapper">
          {!!breakDescription && (
            <Icon
              src="clock"
              width="14px"
              className="white"
              style={{ float: 'left' }}
              alt={breakDescription}
              showTooltip={true}
              tooltipPlace="top"
            />
          )}
          {!!non_working && (
            <Icon
              src="umbrella-beach"
              width="16px"
              style={{ float: 'left' }}
              className="white"
              alt="Non-working"
              showTooltip={true}
              tooltipPlace="top"
            />
          )}
          {!!handoverDescription && (
            <Icon
              src="user-group"
              width="16px"
              style={{ float: 'left' }}
              className="white"
              alt={handoverDescription}
              showTooltip={true}
              tooltipPlace="top"
            />
          )}
          {approved === false && (
            <Icon
              src="edit"
              width="16px"
              style={{ float: 'left', position: 'relative', top: '0' }}
              alt="Not Approved"
              showTooltip={true}
              tooltipPlace="top"
            />
          )}
          {!!telemedicine_only && (
            <Icon
              src="video"
              width="16px"
              style={{ float: 'left', position: 'relative', top: '0', color: 'white' }}
              alt="Telemedicine Only"
              showTooltip={true}
              tooltipPlace="top"
            />
          )}
        </div>
      )}
      <span>{overrideText || description}</span>
      {!!onDelete && shift.id && (
        <Icon
          src="trash"
          className="white on-hover"
          width="16px"
          alt="Remove Shift"
          showTooltip={true}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onDelete();
          }}
        />
      )}
    </div>
  );
};

export default ShiftBadge;
